<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">默认值</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="value" [(ngModel)]="config.value" />
  </nz-form-control>
</nz-form-item>
<!-- 有效值 -->
<nz-form-item>
  <nz-form-label [nzSpan]="6">有效值</nz-form-label>
  <nz-form-control>
    <app-tags-select name="effectiveSelect" ngDefaultControl [dataType]="config.dataType" [(ngModel)]="config.effective"></app-tags-select>
  </nz-form-control>
</nz-form-item>
